import React, { useRef, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
const AccordionRightContent = (props) => {
    const [selectedKey, setSelectedKey] = useState(props.defaultActiveKey ? props.defaultActiveKey : "");
    const scrollRef = useRef(null);
    const scrollToTop = () => {
        scrollRef &&
            scrollRef.current &&
            scrollRef.current.scroll({
                top: 0,
                behavior: "smooth",
            });
    };
    React.useEffect(() => {
        if (props.defaultActiveKey)
            setSelectedKey(props.defaultActiveKey);
    }, [props.defaultActiveKey]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Accordion, { activeKey: selectedKey, onSelect: (key) => setSelectedKey(key), className: `customaccordian ${props.parentClass}` }, props.AccordionArray &&
            props.AccordionArray.map((accordiandata, idx) => {
                const isTotal = accordiandata.eventKey === "Total";
                return (React.createElement(Accordion.Item, { key: idx, eventKey: accordiandata.eventKey },
                    isTotal ? (React.createElement("div", { className: "accordion-header-total flexJustifySpaceBetween bg_lightYellow pdr - 29\r\n" },
                        React.createElement("div", { className: "text-left data-value DMSan_14_700" }, accordiandata.title),
                        React.createElement("div", { className: "text-right d-flex align-items-center justify-content-end  data-value hand_cursor RobotoB_16_700" }, accordiandata.rightContent))) : (React.createElement(Accordion.Header, { onClick: () => {
                            props.handleTitle(accordiandata.title);
                        } },
                        React.createElement("div", { className: "table-head w-100 d-flex justify-content-between pdr-29", key: idx },
                            React.createElement("div", { className: "text-left data-value DMSan_14_500" }, accordiandata.title),
                            React.createElement("div", { className: "text-right d-flex align-items-center justify-content-end  data-value hand_cursor RobotoM_14_500" }, accordiandata.rightContent)))),
                    React.createElement(Accordion.Body, null,
                        React.createElement("div", { key: idx, ref: accordiandata.eventKey === selectedKey &&
                                accordiandata.backToTop
                                ? scrollRef
                                : null, id: "accordion-content", className: accordiandata.backToTop && "setHeight" }, accordiandata.tabContent),
                        accordiandata.backToTop && (React.createElement("div", { className: "accordian-back EncodeSans_12_500 txt-midnight-blue d-flex justify-content-end mt-2", onClick: () => scrollToTop() },
                            React.createElement("i", { className: "edel-icon-point-arrow-up" }),
                            React.createElement("span", null, "Back to top"))))));
            }))));
};
export default AccordionRightContent;
